import SessionEventProto from "../session-event-proto"
import ProjectSettings from '../../manager/project/project-settings/project-settings'
import ProjectSession from "../../model2/project/project-session"
import {SESSION_PROJECT_SETTINGS_CHANGE} from "../../gd/bus/bus-event-type"

export default class EventProjectsSettings extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    validate() {
        return true
    }

    process() {

        _.map(this.data, async (d)=>{
            const sessionProject : ProjectSession | null = gd.session.projects.get(d.id)

            if (!sessionProject) {
                return
            }

            // do not use delta here !
            sessionProject.settings = new ProjectSettings(sessionProject, d.settings)

            // sessionProject.applyDelta({
            //     settings: new ProjectSettings(sessionProject, d.settings)
            // });

            // update project views if delta is for project currently viewed
            if (gd.projectViews?.project.id === d.id) {
                await gd.projectViews.onProjectSettingsChanged(d.id)
            }

            gd.bus.triggerEvent(SESSION_PROJECT_SETTINGS_CHANGE, d.id)
        })
    }
}
